import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ButtonComponentModule, LanternCommonModule } from "@lantern/app/common";
import {
  FormFieldComponentModule,
  InputComponentModule
} from "@lantern/app/common/forms";

import { TestPageComponent } from "./test-page.component";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LanternCommonModule,
    FormFieldComponentModule,
    InputComponentModule,
    ButtonComponentModule
  ],
  declarations: [TestPageComponent],
  exports: [TestPageComponent]
})
export class TestPageModule {}
